import { useState } from "react";

const initialBase = {
  shop: "",
  appId: "",
  lang: "",
  functionId: "",
  validationId: "",
  metafieldId: "",
  shopId: "",
  plan: "",
  timeZone: "",
  timezoneOffset: "",
};

export const useBase = () => {
  const [base, setBase] = useState<
    typeof initialBase & { payment?: { [key: string]: string } }
  >(initialBase);

  const changeBase = (props: {
    appId?: string;
    shop?: string;
    lang?: string;
    functionId?: string;
    validationId?: string;
    metafieldId?: string;
    timeZone?: string;
    payment?: { [key: string]: string };
  }) => {
    setBase((prev) => {
      return { ...prev, ...props };
    });
  };

  return { base, changeBase };
};

export type baseType = ReturnType<typeof useBase>;
